module.exports = __webpack_public_path__ + "static/media/login-background.fdcca464.png";